module.exports = __webpack_public_path__ + "img/austria-tuberculosis-male.bb6b3555.png";